import { scaleOrdinal } from 'd3-scale';
import getEntityKey from 'helpers/getEntityKey';

const getColorScale = (
  colors: string[],
  metricTypes: string[]
): any | undefined => {
  const scale = scaleOrdinal(colors).domain(metricTypes);

  const getColor = (d: string): string => {
    const val = typeof d === 'string' ? d : getEntityKey(d);
    return scale(val) as string;
  };
  return getColor;
};

export default getColorScale;
